export const experience = [
  {
    id: 0,
    title: "Software Engineer @ Garner Distributed Workflow",
    date: "2024 - 2025",
    description:
      "My first industry internship. I learned an incredible amount from highly experienced engineers from all parts of the field. I appreciated not being treated as an 'intern', but just another member of the dev team, who pulls off the same Jira backlog and does the same tasks as everyone else. It was true fullstack development, as I worked on everything including database, backend, frontend, jobs/imports, various microservices, build/infrastructure (Github Actions, k8s, and Google Cloud), UI/UX and more. It was an Agile/Xp team of highly skilled generalists, and it was a priveledge to work there.",
    accomplishments: [
      "Maintained and significantly upgraded ONgDB (Open source Neo4J fork), and migrated our entire production database (>1 billion nodes) to it.",
      "Implemented and designed an entire logistical filtering DSL from scratch, increasing the capability and usability of the filtering system.",
      "Created a variety of k8s infrastructure in dhall and yaml, github actions, and other google cloud configuration.",
      "Refactored large parts of the frontend to remove significant duplicatation (Thousands of lines) and make components more modular",
      "Developed CronJobs to handle millions of rows of data imports from a variety of external vendor APIs",
      "Implemented self signup through Auth0 API alongside our existing SSO and user import systems",
      "Wrote E2E tests in both Cypress and Playwright",
    ],
    tags: [
      "Scala",
      "ZIO",
      "Play",
      "Angular",
      "Typescript",
      "Kubernetes",
      "Neo4J",
      "Cypher",
      "Git",
      "Github Actions",
      "E2E Testing",
      "Dhall",
      "Bash",
      "Regex",
    ],
    link: "https://www.garnercorp.com/",
  },
  {
    id: 1,
    title: "Machine Learning Researcher @ Pardee Lab",
    date: "2023 - Present",
    description:
      "My first field internship on a small computational group of other software developers overseen by a PHD biologist. I have had the opportunity to learn lots about the processes of research, to submit papers, and to act as a leader of a team. I worked here full time for 4 months, and I am continuing part time for the remainder of my undergrad.",
    accomplishments: [
      "Implemented a distributed computing platform on Google Cloud using the MongoDB API to distribute the workload of protein structure prediction for a genetic algorithm, reducing the running time by a factor of ~20.",
      "Developed multiple machine learning models, mostly Pytorch based to predict protein functionality from sequence and/or structural data",
      "Implemented my own custom tree based genetic algorithm which behaves similarly to a family tree, where we always extend the tree from the best performing children",
      "Researched biology and machine learning, keeping up to date on cutting edge research in the field, and brainstorming projects of our own.",
      "Organized and distributed work to a team of 4 other developers.",
      "Managed the use of a shared workstation including multiple environments and operating systems",
      "Developed a paper on creating a multi-armed model to predict protein functionality with only ~120 data points, and generate new functional proteins using a genetic algorithm",
      "Worked on a meta analysis of protein LLMs and their performance with QLoRA adaptions.",
      "Published two papers at ICLR 2025 (openreview.net/forum?id=sfTXIiu7Op, openreview.net/forum?id=KBMxaCSwpB)",
    ],
    tags: [
      "Python",
      "PyTorch",
      "Machine Learning",
      "Biology",
      "Google Cloud",
      "PostgreSQL",
      "Bash",
      "Research",
    ],
    link: "https://www.pardeelab.org/",
  },
];
